jQuery(($) => {

    if ($('.m-video-embed')[0]) {
        $('.m-video-embed__button').click(function () {
            var videoID    = $(this).attr('aria-controls'),
                videoEmbed = $(`#${videoID}`);

            if (videoEmbed) {
                var dataSource = videoEmbed.data('src');

                videoEmbed.attr('src', dataSource);

                videoEmbed.parents('.m-video-embed').addClass('m-video-embed--playing');
            }
        });
    }
});